// extracted by mini-css-extract-plugin
export default {"audioPlayer":"audio-player-module_audioPlayer_WKDsV","errorText":"audio-player-module_errorText_tFALA","cardContent":"audio-player-module_cardContent_vaTYY"};